import React from 'react';
import {Link} from 'react-router-dom';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

class Scenarios extends React.Component{

  componentDidMount() {
//    console.log('Active --> ', this.props.scenario);
  }

  buildClass = (s) => {
    let classname = "scenario scenarioBg";
    if (this.props.scenario === s.Slug){
      classname = "scenario scenarioBg active light " + s.Slug;
    }
    else{
      classname = "scenario scenarioBg " + s.Slug;
    }
    return classname;
  }

  render() {
    return(
        <div className="scenarios">
          <Row>
            {
              this.props.scenarios.map(obj => {
                return (
                  <Col key={obj.Slug}>
                    <Link to={`/s/${obj.Slug}`}>
                      <div className={this.buildClass(obj)}>
                        <p className="tag">Scenario {obj.Nr}/4</p>
                        <p className="title">{obj.Title}</p>
                      </div>
                    </Link>
                  </Col>
                )
              })
            }
          </Row>
        </div>
    )
  }
}
export default Scenarios;



// WEBPACK FOOTER //
// ./src/components/Scenarios/scenarios.js